const { calculateFactionFromStrategy } = require('./factionFromStrategy');

/**
 * Resolve the canonical English player faction for battle-end presentation.
 * @param {{
 *   playerFactionName?: string|null,
 *   gameState?: object|null,
 *   userId?: string|number|null,
 * }} params
 * @returns {string}
 */
function resolvePlayerFactionFromBattleContext({
  playerFactionName,
  gameState,
  userId,
}) {
  if (playerFactionName) {
    return playerFactionName;
  }

  if (!gameState?.state) {
    throw new Error('resolvePlayerFactionFromBattleContext: gameState.state is required');
  }
  if (userId == null || userId === '') {
    throw new Error('resolvePlayerFactionFromBattleContext: userId is required');
  }

  const playerState =
    gameState.state[userId] ??
    gameState.state[String(userId)] ??
    gameState.state[Number(userId)];

  if (!playerState?.strategy) {
    throw new Error('resolvePlayerFactionFromBattleContext: player strategy missing from gameState');
  }

  const faction = calculateFactionFromStrategy(playerState.strategy);
  if (!faction || faction === 'Unknown') {
    throw new Error('resolvePlayerFactionFromBattleContext: could not derive faction from player strategy');
  }

  return faction;
}

module.exports = {
  resolvePlayerFactionFromBattleContext,
};
